// extracted by mini-css-extract-plugin
export default {"profile_img":"ProfileAvatar_profile_img__a9VoE"};